export enum AttributeType {
  INTEGER = 'Integer',
  DOUBLE = 'Double',
  FILE = 'File',
  STRING = 'String',
  LIST = 'List',
  PHOTO = 'Photo',
}

export const fromOldAttributeType = (oldType: string): AttributeType => {
  switch (oldType) {
    case 'integer':
      return AttributeType.INTEGER;
    case 'double':
      return AttributeType.DOUBLE;
    case 'file':
      return AttributeType.FILE;
    case 'string':
      return AttributeType.STRING;
    case 'List':
      return AttributeType.LIST;
    case 'photo':
      return AttributeType.PHOTO;
    default:
      return AttributeType.STRING;
  }
};

export const toOldAttributeType = (type: AttributeType): string => {
  switch (type) {
    case AttributeType.INTEGER:
      return 'integer';
    case AttributeType.DOUBLE:
      return 'double';
    case AttributeType.FILE:
      return 'file';
    case AttributeType.STRING:
      return 'string';
    case AttributeType.LIST:
      return 'List';
    case AttributeType.PHOTO:
      return 'photo';
    default:
      return 'string';
  }
};
